'use client';

import { useTranslations } from 'next-intl';
import BringOrder from '@/components/bring-order/BringOrder';

const BackendBringOrderSection = () => {
  const t = useTranslations('BackendBringOrderSection');

  return (
    <BringOrder
      title={t('title')}
      description={t('description')}
      primaryBtn={t('primaryButtonLabel')}
      showPrimaryButton={false}
      secondaryBtn={t('secondaryButtonLabel')}
      secondaryBtnTargetId="contact"
      secondaryBtnScrollOffset={82}
    />
  );
};

export default BackendBringOrderSection;
